import OnlineOrderValuesModel from "../../../../services/models/formModels/onlineOrderValues.model";
import CustomText from "../../../atomic/CustomText";
import DetailRenderer from "../DetailRenderer";

function ShipmentInformationReview({
  values,
}: {
  values: OnlineOrderValuesModel;
}) {
  return (
    <div id="shipment info">
      {/* Shipment Information Section */}
      <div className="reviewCard mt-6">
        <DetailRenderer
          data={{
            isTissueShipped: values.isTissueShipped,
            shipTracking: values.shipTracking,
            shipMethod: values.shipMethod,
          }}
          groupFields={["isTissueShipped", "shipTracking", "shipMethod"]}
          hiddenFields={[]}
          MainHeading="Shipment Information"
        />
      </div>
    </div>
  );
}
export default ShipmentInformationReview;
